import React, { FC, useContext, MouseEvent } from 'react'
import clsx from 'clsx'
import { OptionProps } from 'react-select'

import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'

import FirestoreService from '../../../../../services/firestoreService'

import useToasterHelper from '../../../../../helpers/ToasterHelper'
import { getConvertedData } from '../../../../../models/interface.helper'

import { ScoreCardModel } from '../../../../../models/score-cards/score-cards.model'

import { IJudgeOption } from '../../../../../models/event-fees/event-fees.interface'
import { RegistrationFeesTypeEx } from '../ManageClinicNOtherOperationsTab/ManageClinicNOtherOperationsTab'

import { CONST } from '../../../../../const/const'
import { MODAL_CONSTS } from '../../../../../const/modal-const'
import { MESSAGES_CONST } from '../../../../../const/messages-const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

interface ScoreCardOptionProps extends OptionProps<IJudgeOption, false> {
  row: RegistrationFeesTypeEx
}

export const ScoreCardOption: FC<ScoreCardOptionProps> = (props) => {
  const { data, innerProps, innerRef, selectProps } = props

  const toastFunctions = useToasterHelper()

  const handleModalContext = useContext(HandleModalContext)
  const handleModal = handleModalContext?.handleModal

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (data.onAddScoreCard) {
      e.stopPropagation()
      selectProps?.onMenuClose?.()
      handleModal?.(true, MODAL_CONSTS.ADD_SCORE_CARD, { judges: props.row.judges })
    } else {
      innerProps?.onClick?.(e)
    }
  }

  const onDelete = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    selectProps?.onMenuClose?.()
    handleModal?.(true, MODAL_CONSTS.REMOVE_CONFIRMATION, {
      alertText: 'Are you sure you want to delete this score card?',
      submitButtonName: 'Delete',
      removeItem: async () => {
        try {
          await FirestoreService.deleteItem(COLLECTIONS.SCORE_CARDS.NAME, data.value)

          toastFunctions.success({ message: MESSAGES_CONST.SCORE_CARD_DELETED })
        } catch (e) {
          console.error(e)
          toastFunctions.success({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
        }
      },
    })
  }

  const onDuplicate = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    selectProps?.onMenuClose?.()
    handleModal?.(true, MODAL_CONSTS.REMOVE_CONFIRMATION, {
      alertText: 'Are you sure you want to duplicate this score card?',
      submitButtonName: 'Duplicate',
      removeItem: async () => {
        try {
          const scoreCardsSnaps = await FirestoreService.getItem(
            COLLECTIONS.SCORE_CARDS.NAME,
            data.value
          )

          const scoreCard = getConvertedData(
            ScoreCardModel.fromFirestoreDoc(scoreCardsSnaps).toObject()
          )

          await FirestoreService.createItem(
            COLLECTIONS.SCORE_CARDS.NAME,
            new ScoreCardModel({ ...scoreCard, name: `${scoreCard.name} Duplicated` }).toFirestore()
          )
          toastFunctions.success({ message: MESSAGES_CONST.SCORE_CARD_DUPLICATED })
        } catch (e) {
          console.error(e)
          toastFunctions.success({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
        }
      },
    })
  }

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={clsx(
        'py-2 px-3 cursor-pointer hover:bg-SeabiscuitGrayThemeColor flex justify-between items-center',
        data.isBorderTop && 'border-t border-t-SeabiscuitLightThemeColorD3'
      )}
      onClick={handleClick}
    >
      <span className="text-left text-[13px] text-SeabiscuitDark200ThemeColor">{data.label}</span>
      {data?.isCustom && (
        <div className="text-sm text-SeabiscuitDark200ThemeColor/50 flex gap-1 items-center">
          <button className="underline hover:no-underline" onClick={onDelete}>
            Delete
          </button>
          |
          <button className="underline hover:no-underline" onClick={onDuplicate}>
            Duplicate
          </button>
        </div>
      )}
    </div>
  )
}
